import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";
import {V1ObjectRevisionIDOCToArray} from "../../../../util/Payload";

/**
 * The records that may be ADDED to a change order, for the picker on "Add record".
 *
 * ITS OWN COMPONENT for the same two reasons RelatableObject is: ObjectRevision keeps its
 * classification in a MODULE-LEVEL variable, so a picker borrowing it inherits whichever
 * classification the page happens to be showing -- and it would be wrong even if it worked, because
 * a change order may legitimately span classifications. A specification change that does not touch
 * the item it specifies is the unusual case, not the normal one.
 *
 * DRAFTS ONLY, and that is the difference from RelatableObject. A change order releases what it
 * carries, so a record already released has nothing for it to do: putting one in would produce a
 * package whose close is a no-op for that member while its signatures imply otherwise. The server
 * refuses it with CC-CORD-MDFT; this keeps the chooser from offering it in the first place.
 */
const URL = "t1/v1/object_revisions";
const IDOC = "v1.ObjectRevision-001";

class ChangeOrderCandidateEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        const members = [{"Type": "Attribute", "Name": "Status", "Value": "DRAFT", "Operator": "EQUAL"}];

        // Whatever the chooser's search box is asking for, on top of the current-revision floor.
        const typed = this.prepareQueryPayload();
        if (typed && typed.size > 0) {
            for (const [key, value] of typed) {
                if (key.includes("_query") || key === "Status") continue;
                const operator = typed.get(key + "_query") ?? "EQUAL";
                members.push({"Type": "Attribute", "Name": key, "Value": value, "Operator": operator});
            }
        }

        const QBE = {
            "PlatformMessage": {
                "-idoc": IDOC,
                "-id": uuidv4(),
                "ObjectRevision": {
                    "_attributes": {
                        "limit": pageSize,
                        "sort": this.getFormattedSortSpecification() || "Name:ASC",
                        "offset": (page - 1) * pageSize,
                    },
                    "QueryGroups": {
                        "QueryGroup": [{
                            "Name": "primary", "Operator": "AND", "Type": "QueryGroup",
                            "Membership": {"Member": members},
                        }],
                    },
                },
            },
        };

        AxiosFoundationAPI({
            method: "GET",
            url: URL,
            json: true,
            params: {"QBE": btoa(JSON.stringify(QBE))},
            headers: {
                "visibility-mode": this.getVisibilityMode(),
                "visibility-value": this.getVisibilityValue(),
                "idoc-response": IDOC,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ObjectRevisionIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };
}

export default ChangeOrderCandidateEnterpriseComponent;
